/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * OlBannerApi - axios parameter creator
 * @export
 */
export const OlBannerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Record OL banner click
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordOlBannerClick: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('recordOlBannerClick', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organizationId}/ol-banner-clicks`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OlBannerApi - functional programming interface
 * @export
 */
export const OlBannerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OlBannerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Record OL banner click
         * @param {string} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordOlBannerClick(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordOlBannerClick(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OlBannerApi - factory interface
 * @export
 */
export const OlBannerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OlBannerApiFp(configuration)
    return {
        /**
         * 
         * @summary Record OL banner click
         * @param {OlBannerApiRecordOlBannerClickRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordOlBannerClick(requestParameters: OlBannerApiRecordOlBannerClickRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recordOlBannerClick(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for recordOlBannerClick operation in OlBannerApi.
 * @export
 * @interface OlBannerApiRecordOlBannerClickRequest
 */
export interface OlBannerApiRecordOlBannerClickRequest {
    /**
     * 
     * @type {string}
     * @memberof OlBannerApiRecordOlBannerClick
     */
    readonly organizationId: string
}

/**
 * OlBannerApi - object-oriented interface
 * @export
 * @class OlBannerApi
 * @extends {BaseAPI}
 */
export class OlBannerApi extends BaseAPI {
    /**
     * 
     * @summary Record OL banner click
     * @param {OlBannerApiRecordOlBannerClickRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OlBannerApi
     */
    public recordOlBannerClick(requestParameters: OlBannerApiRecordOlBannerClickRequest, options?: AxiosRequestConfig) {
        return OlBannerApiFp(this.configuration).recordOlBannerClick(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}
